import { navigate, NavigateOptions } from "@reach/router";
import { useCallback } from "react";

/**
 * Thin imperative-navigate wrapper living outside `newui/` (which bans a
 * direct `@reach/router` import) — companion to `RfxTabLink`/`RfxRouterLink`
 * for callers that need `navigate()` rather than a `<Link>`, e.g. redirecting
 * away from a 403 in an effect (TASK-014 AC3 friendly redirect).
 */
export const useRfxNavigate = () =>
	useCallback(
		(to: string, options?: NavigateOptions<Record<string, unknown>>) =>
			navigate(to, options),
		[]
	);
